import styled from 'styled-components'

export const Container = styled.div`
  margin-left: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
  .left-section {
    color: #4c6072;
    font-size: 18px;
    .v {
      letter-spacing: 0.3px;
      line-height: 27px;
      font-weight: 500;
      &.placeholder {
        color: rgba(169, 169, 169, 0.7);
      }
    }
    .input {
      padding: 0 4px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid #b8c4df;
      background: #e5eef5;
      font-weight: 500;
      letter-spacing: 0.3px;
      &:disabled {
        opacity: 0.7;
      }
    }
  }
  .edit-icon {
    margin-left: 10px;
  }
  &.editing {
  }
`
